<div class="tw-flex tw-flex-col tw-w-full tw-p-6 tw-gap-5 md:tw-gap-2">
    <h3>{{data.title}}</h3>
    <h5>{{data.content}}</h5>
    <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-x-20">
        <pickright-button type="outline" text="{{data.cancelBtn}}" (btnClick)="onCancel()"></pickright-button>
        <pickright-button type="fill" text="{{data.okBtn}}" (btnClick)="onSuccess()"></pickright-button>
    </div>
</div>